import Navbar from "@/components/Navbar";
import Hero from "@/components/sections/Hero";
import Services from "@/components/sections/Services";
import HowItWorks from "@/components/sections/HowItWorks";
import Pricing from "@/components/sections/Pricing";
import FunderMarketplace from "@/components/sections/FunderMarketplace";
import About from "@/components/sections/About";
import Testimonials from "@/components/sections/Testimonials";
import FAQ from "@/components/sections/FAQ";
import CTA from "@/components/sections/CTA";
import Footer from "@/components/sections/Footer";
import ChatWidget from "@/components/ChatWidget";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="min-h-screen bg-cream font-body text-umber">
      <Navbar />
      <main>
        <Hero />
        <Services />
        <HowItWorks />
        <Pricing />
        <FunderMarketplace />
        <About />
        <Testimonials />
        <FAQ />
        <CTA />
      </main>
      <Footer />
      <ChatWidget />
    </div>
  );
}
